<div *ngIf="data !== null" class="skill">
  <div class="icon-user">
    <img src="assets/img/circle-user.svg" alt="user" class="disabled" *ngIf="data.average.self.last_saved.value === null">
    <img src="assets/img/circle-user-active.svg" (click)="openDevReport()" alt="user" *ngIf="data.average.self.last_saved.value !== null">
  </div>
  <div class="icon-plus">
    <img src="assets/img/plus.svg" alt="plus" class="disabled"
         *ngIf="data.average.manager.last_saved.value !== null || !data.active.learner">
    <img src="assets/img/plus-active.svg" (click)="addSkillReport()" alt="plus"
         *ngIf="data.average.manager.last_saved.value === null && data.active.learner">
  </div>

  <div class="title">{{data.name?data.name:'SkillsChecker'}}</div>

  <div class="element">
    <div class="box">
      <div class="line">
        {{'__SC_SUMMARY_LEARNER__' | translate}}:
        <span class="my-color-red" *ngIf="!active">-</span>
        <span class="my-color-red" *ngIf="active">{{data.learner_start_date.output.medium}} - {{data.learner_deadline.output.medium}}</span>
      </div>
      <div class="line">
        {{'__SC_SUMMARY_MANAGER__' | translate}}:
        <span *ngIf="data.type == 'l'">-</span>
        <span *ngIf="data.type == 'lm'" class="my-color-red">{{data.manager_start_date.output.medium}} - {{data.manager_deadline.output.medium}}</span>
      </div>
    </div>
    <div class="status">
      {{'__SC_SUMMARY_STATUS__' | translate}}:
      <span class="my-color-grey" *ngIf="!active || !data.completed.self">{{'__SC_SUMMARY_INCOMPLETED__' | translate}}</span>
      <span class="my-color-green" *ngIf="active && data.completed.self">{{'__SC_SUMMARY_COMPLETED__' | translate}}</span>
    </div>
  </div>


  <div class="line">
    <div class="el">
      {{'__SC_SUMMARY_LEARNER_COMPLETED__' | translate}}<br>
      <div *ngIf="active" class="my-color-red">{{data.average.self.last_saved.output.medium}}</div>
    </div>
    <div class="el">
      {{'__SC_SUMMARY_MANAGER_COMPLETED__' | translate}}<br>
      <div *ngIf="data.type == 'l'">-</div>
      <div *ngIf="data.type == 'lm'" class="my-color-red">{{data.average.manager.last_saved.output.medium}}</div>
    </div>
  </div>

  <div class="group">
    <div class="el">
      {{'__SC_SUMMARY_SELF__' | translate}}
      <span *ngIf="!active">-</span>
      <span *ngIf="active" class="active {{data.average.self.average.output.style.class}}">
        {{data.average.self.average.output.value}}
      </span>
    </div>
    <div class="el">
      {{'__SC_SUMMARY_MANAGER__' | translate}}
      <span *ngIf="data.type == 'l'">-</span>
      <span *ngIf="data.type == 'lm'" class="active {{data.average.manager.average.output.style.class}}">
        {{data.average.manager.average.output.value}}
      </span>
    </div>
    <div class="el">
      {{'__SC_SUMMARY_GAP__' | translate}}
      <span *ngIf="data.type == 'l'">-</span>
      <span *ngIf="data.type == 'lm'" class="active {{data.average.gap.average.output.style.class}}">
        {{data.average.gap.average.output.value}}
      </span>
    </div>
    <div class="el">
      {{'__SC_SUMMARY_AGREED__' | translate}}
      <span *ngIf="data.type == 'l'">-</span>
      <span *ngIf="data.type == 'lm'" class="active {{data.average.agreed.average.output.style.class}}">
        {{data.average.agreed.average.output.value}}
      </span>
    </div>
  </div>
</div>
